// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8eb503e4","455":"374e1d7d"}[chunkId] + ".chunk.js";
};